var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"surgery-delete-modal","content-class":"delete-modal-content","title":"Supprimer une chirurgie","ok-title":"Supprimer","ok-variant":"danger","cancel-title":"Annuler"},on:{"ok":_vm.handleOk}},[(_vm.selected)?_c('div',[_vm._v("\n    Supprimer la chirurgie \""+_vm._s(_vm.selected.name)+"\" ?\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670cb082","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/surgery/SurgeryDeleteModal.vue
// module id = 131U
// module chunks = 0